<template>
    <div>
        <ValidationObserver ref="createModalValidate">
                <b-col cols="12">
                    <ValidationProvider name="name" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('name')">
                            <b-form-input type="text" v-model="formData.name"
                                          :state="errors[0] ? false : null"
                            />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>

            <div class="d-flex justify-content-center mt-2">
                <b-button variant="primary" @click="createForm" :disabled="formLoading">
                    {{ $t('save') }}
                </b-button>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>

    // Other
import {ValidationObserver, ValidationProvider} from 'vee-validate'
import ConcentrationsServices from '../../../../services/ConcentrationsServices';

    export default {
        props:{
            programCode: {
                type: String,
                default: ''
            }
       
        },
        components: {
            ValidationObserver,
            ValidationProvider
        },
        data() {
            return {
                formData: {
                    name: null,
                    
                },
                formLoading: false
            }
        },
        methods: {
            async createForm() {
                const isValid = await this.$refs.createModalValidate.validate();
                if (isValid) {
                    this.formData.program_code=this.programCode;
                    ConcentrationsServices.store(this.formData)
                                                    .then(response => {
                                                        this.$toast.success(this.$t('api.' + response.data.message));
                                                        this.$emit('createFormSuccess', true);
                                                    })
                                                    .catch(e => {
                                                        this.showErrors(e, this.$refs.formModalValidate);
                                                    })
                                                    .finally(() => {
                                                        this.formLoading = false
                                                    })
                    
                    this.formLoading = true;
                   
                }
            }
        }
    }
</script>

